import { useEffect, useState } from 'react';
import {
  get as storageGet,
  set as storageSet,
  STORAGE_KEYS,
} from '@/utils/storage';

export const ADMIN_SIDEBAR_COLLAPSED_EVENT = 'admin-sidebar-collapsed-changed';

const read = () => storageGet(STORAGE_KEYS.ADMIN_SIDEBAR_COLLAPSED) === true;

export function useSidebarCollapsed(): [boolean, (next: boolean) => void] {
  const [collapsed, setCollapsedState] = useState(false);

  useEffect(() => {
    setCollapsedState(read());
    const refresh = () => setCollapsedState(read());
    const onStorage = (e: StorageEvent) => {
      if (e.key === STORAGE_KEYS.ADMIN_SIDEBAR_COLLAPSED) refresh();
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener(ADMIN_SIDEBAR_COLLAPSED_EVENT, refresh);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener(ADMIN_SIDEBAR_COLLAPSED_EVENT, refresh);
    };
  }, []);

  const setCollapsed = (next: boolean) => {
    storageSet(STORAGE_KEYS.ADMIN_SIDEBAR_COLLAPSED, next);
    window.dispatchEvent(new CustomEvent(ADMIN_SIDEBAR_COLLAPSED_EVENT));
  };

  return [collapsed, setCollapsed];
}
